// Páginas que van solas, sin el menú ni el footer del sitio (páginas de salida, como la bio de las redes).
const STANDALONE = ['/enlaces', '/agenda', '/equipo'];

export const isStandalone = (pathname) =>
  STANDALONE.some((p) => pathname === p || pathname?.startsWith(`${p}/`));
